/** CoStar.Api.EnterpriseSub2.Shapes.ShapeType */
export var ShapeType;
(function (ShapeType) {
    ShapeType[ShapeType["Unknown"] = 0] = "Unknown";
    ShapeType[ShapeType["PostalCode"] = 2] = "PostalCode";
    ShapeType[ShapeType["City"] = 3] = "City";
    ShapeType[ShapeType["Submarket"] = 5] = "Submarket";
    ShapeType[ShapeType["Street"] = 6] = "Street";
    ShapeType[ShapeType["ResearchMarket"] = 7] = "ResearchMarket";
    ShapeType[ShapeType["County"] = 10] = "County";
    ShapeType[ShapeType["Subdivision"] = 11] = "Subdivision";
    ShapeType[ShapeType["Country"] = 15] = "Country";
    ShapeType[ShapeType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    ShapeType[ShapeType["Region"] = 17] = "Region";
    ShapeType[ShapeType["CBSA"] = 18] = "CBSA";
    ShapeType[ShapeType["CSA"] = 19] = "CSA";
    ShapeType[ShapeType["DMA"] = 20] = "DMA";
    ShapeType[ShapeType["Cluster"] = 21] = "Cluster";
    ShapeType[ShapeType["University"] = 26] = "University";
    ShapeType[ShapeType["Metro"] = 32] = "Metro";
    ShapeType[ShapeType["School"] = 37] = "School";
    ShapeType[ShapeType["SchoolDistrict"] = 39] = "SchoolDistrict";
    ShapeType[ShapeType["CoStarMarket"] = 132] = "CoStarMarket";
})(ShapeType || (ShapeType = {}));
